import { CheckboxWithLabel, type CheckboxWithLabelProps } from "~/common/components/CheckboxWithLabel";
import { Trans, useTranslation } from "react-i18next";
import classes from "./TrainingConsent.module.less";
import { LMS_TRAINING_OVERVIEW_URL } from "~/utils/url/staticUrls";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

export const TrainingConsent = (props: Omit<CheckboxWithLabelProps, "children">) => {
  const { t } = useTranslation();
  const isDesktop = useIsMinDesktopSize();

  return (
    <div className={classes.box}>
      {!isDesktop && <div className={classes.flag}>{t("myAccount.training.flag.label")}</div>}
      <div className={classes.title}>
        <Trans i18nKey={"myAccount.training.title"}>
          We are pleased to invite you to our new Schaeffler Training Campus, where you will find all training and
          certification courses offered by the Schaeffler Group worldwide for the Industrial Division. Develop your
          future skills, turn your competence into value and benefit from our expert knowledge and decades of practical
          experience. Tick the box below to enter the details required to access the
          <a href={LMS_TRAINING_OVERVIEW_URL} target="_blank">
            Schaeffler Training Campus.
          </a>
        </Trans>
      </div>
      <CheckboxWithLabel {...props}>
        <Trans
          i18nKey={"myAccount.training.terms.label"}
          components={[<span />, <b />, <span />, <a href={window.SCHA.urls.lmsTermsConditions} target="_blank" />]}
        >
          I would like to enter the additional fields and gain access to the
          <b>Schaeffler Training Campus</b>, and by clicking on the “Submit” button below I confirm that I have read and
          accepted the{" "}
          <a href={window.SCHA.urls.lmsTermsConditions} target="_blank">
            Terms of use
          </a>
          .
        </Trans>
      </CheckboxWithLabel>
    </div>
  );
};
